import React from "react";
import ReactDOM from "react-dom";
import {Provider} from 'mobx-react';

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import {dataStore} from './stores';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

import AdminLayout from "layouts/Admin.jsx";
const dataStoreClass = new dataStore();
const stores = {dataStore: dataStoreClass};


ReactDOM.render(
<Provider {...stores}>
  <BrowserRouter>
    <Switch>
      <Route path="/admin" render={props => <AdminLayout {...props} />} />
      <Redirect from="/" to="/admin/dashboard" />
    </Switch>
  </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);